module.exports = __webpack_public_path__ + "25_pvis.jpg?f61d8744892b4ce9db6d2e2929c34b2d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/25_pvis.jpg
// module id = 216
// module chunks = 0